export default {
  data() {
    return {
      errors: {},
    };
  },

  methods: {
    formHasErrors() {
      return !_.isEmpty(this.errors);
    },

    /*
     * Example usage:
     *    :class="{'is-invalid': hasAttrError('name')}"
     */
    hasAttrError(attr) {
      return typeof this.errors[attr] !== 'undefined' && !_.isEmpty(this.errors[attr]);
    },

    addAttrError(attr, message) {
      // TODO Do not add if message already exists
      this.$set(this.errors, attr, [message]);
    },

    // TODO Search and remove a specific message if specificMessage is set
    removeAttrError(attr, specificMessage = null) {
      if (this.hasAttrError(attr)) {
        this.$delete(this.errors, attr);
      }
    },

    /*
     * Example usage: <div v-for="msg in getAttrError('name')" class="invalid-feedback">{{ msg }}</div>
     * Note the v-for loop
     */
    getAttrError(attr) {
      if (this.hasAttrError(attr)) {
        return this.errors[attr];
      }

      return null;
    },

    clearErrors() {
      this.errors = {};
    },
  },
};
